export const ScreenPath = '/ReactMyAccountOrders/';

export const ScreenName = 'Orders';
